import "../plugins/apollo.js";
import { useAuth } from "../plugins/banza/auth.js";
import "axios";
import "lodash-es";
import "pinia";
import "../store/index.js";
import "../plugins/i18n.js";
import "../assets/e94e4817134d7c25.png";
import "../assets/5341da3ffbec0137.png";
import "../assets/01f50022317dccd7.png";
import "maska";
import "vue";
import "vue-router";
import "../graphql/queries.js";
import "../graphql/subscriptions.js";
import "vuetify";
import "moment";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../constants/components/index.js";
/* empty css                                    */
import "vuetify/components/VDialog";
import "../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                                   */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                             */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../assets/8a32dc557a826bf0.png";
/* empty css                                */
import "../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                            */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../components/Auth/AppleAuthButton/AppleAuthButton.js";
import "../components/Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../components/Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../components/Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../components/Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                          */
import "vuetify/components/VGrid";
import "../components/Base/index.js";
import "vuex";
/* empty css                                   */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../icons/mdi/index.js";
/* empty css                                       */
import "vuetify/components/VBtnToggle";
import "../assets/6f5dc1ff0a697731.svg";
import "../assets/888bb8db73be3c15.svg";
/* empty css                                        */
import "vuetify/components/VInfiniteScroll";
/* empty css                                             */
/* empty css                                 */
import "vuetify/components/VChip";
/* empty css                                     */
import "../components/HtmlEditor/index.js";
import "../components/Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../components/Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                          */
/* empty css                                   */
import "../components/News/NewsModule/NewsModule.vue.js";
import "../components/News/NewsModule/NewsList.vue.js";
import "../graphql/news.js";
/* empty css                                   */
import "../components/Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                            */
import "vuetify/components/VWindow";
import "../assets/5a0af7dd23957928.png";
import "../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                                        */
/* empty css                                               */
import "vuetify/components/VHover";
import "../constants/NewsGroup.js";
/* empty css                                                */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                              */
import "vuetify/components/VBottomSheet";
import "../graphql/favorites.js";
import "../plugins/tracker/page-tracker.js";
/* empty css                                        */
import "../graphql/notifications.js";
/* empty css                                             */
import "../constants/CommunicationChannels.js";
/* empty css                                       */
import "vuetify/components/VColorPicker";
/* empty css                                                           */
import "vuetify/components/VTextarea";
/* empty css                                                        */
/* empty css                                     */
import "graphql-tag";
import "../graphql/entity.js";
import "../graphql/lookups.js";
/* empty css                                  */
import "vuetify/components";
/* empty css                                        */
/* empty css                                */
import "../graphql/system-events.js";
/* empty css                                                   */
/* empty css                                    */
import "vuetify/components/VTooltip";
/* empty css                                    */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../graphql/files.js";
/* empty css                                       */
import "vuetify/components/VForm";
/* empty css                                            */
/* empty css                                                          */
import "vuetify/components/VAlert";
/* empty css                                               */
import "vue-dndrop";
/* empty css                                                       */
/* empty css                                               */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                                   */
import "vuetify/components/VFileInput";
/* empty css                                       */
import "vuetify/components/VAvatar";
/* empty css                                             */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                         */
import "../graphql/public-articles.js";
/* empty css                                                      */
/* empty css                                          */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                             */
import "vuetify/components/VItemGroup";
/* empty css                                        */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                                   */
import "../graphql/quartz.js";
import "vue-i18n";
import "../graphql/integration-systems.js";
import "../constants/IntegrationSystemLogDirection.js";
/* empty css                                                                 */
/* empty css                                               */
import "../graphql/session-store.js";
import "../composables/useModalPage.js";
import "../icons/portal/index.js";
const routerMiddleware = (to) => {
  var _a, _b, _c, _d, _e, _f;
  const auth = useAuth();
  if (to.path !== to.path.toLowerCase()) {
    return navigateTo(to.path.toLowerCase());
  }
  const isAuthenticated = auth.isAuthenticated();
  if (!isAuthenticated && ((_a = to.meta) == null ? void 0 : _a.layout) !== "public") {
    return navigateTo("/signin");
  }
  if (isAuthenticated && to.path.includes("/signin")) {
    return navigateTo("/");
  }
  if (isAuthenticated) {
    if (auth.isAdmin()) {
      return;
    }
    if (((_c = (_b = to.meta) == null ? void 0 : _b.policies) == null ? void 0 : _c.length) && !auth.hasOneOfPolicies(to.meta.policies)) {
      return showError({ statusCode: 403 });
    }
    if (((_e = (_d = to.meta) == null ? void 0 : _d.roles) == null ? void 0 : _e.length) && !auth.hasOneOfRoles(to.meta.roles)) {
      return showError({ statusCode: 403 });
    }
    if ((_f = to.meta) == null ? void 0 : _f.admin) {
      return showError({ statusCode: 403 });
    }
  }
};
export {
  routerMiddleware
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
